import { relations } from 'drizzle-orm';
import { patientPaymentMethods } from '../models/patientPaymentMethods';
import { users } from '../../user/models/users';

/**
 * @group Patient
 * @summary Patient payment method relations for the database schema
 *
 * @remarks
 * Defines the relationships for the patientPaymentMethods table, including the many-to-one
 * relationship with users for patient payment methods.
 *
 * @example
 * ```typescript
 * import { patientPaymentMethodRelations } from '@shared/db';
 *
 * // Query payment method with user details
 * const paymentMethodWithUser = await db.query.patientPaymentMethods.findFirst({
 *   where: eq(patientPaymentMethods.id, paymentMethodId),
 *   with: {
 *     user: true
 *   }
 * });
 * 
 * // Query user with all payment methods
 * const userWithPaymentMethods = await db.query.users.findFirst({
 *   where: eq(users.id, userId),
 *   with: {
 *     patientPaymentMethods: true
 *   }
 * });
 * 
 * // Query user with default payment method
 * const userWithDefaultPayment = await db.query.users.findFirst({
 *   where: eq(users.id, userId),
 *   with: {
 *     patientPaymentMethods: {
 *       where: eq(patientPaymentMethods.is_default, true)
 *     }
 *   }
 * });
 * ```
 */
export const /**
 * @internal
 */
patientPaymentMethodRelations = relations(patientPaymentMethods, ({ one }) => ({
  user: one(users, {
    fields: [patientPaymentMethods.user_id],
    references: [users.id],
  }),
}));
